export default __webpack_public_path__ + "clientapp/media/robot-02.259d023a.png";